module.exports = __webpack_public_path__ + "static/media/deposit-icon.b97e3c2a.svg";